import { render, staticRenderFns } from "./DatatableAprovarDispensa.vue?vue&type=template&id=909a3002"
import script from "./DatatableAprovarDispensa.vue?vue&type=script&lang=js"
export * from "./DatatableAprovarDispensa.vue?vue&type=script&lang=js"
import style0 from "./DatatableAprovarDispensa.vue?vue&type=style&index=0&id=909a3002&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports